export const PROGRESSREPORT_GET = 'PROGRESSREPORT_GET';
export const PROGRESSREPORTDETAIL_GET = 'PROGRESSREPORTDETAIL_GET';
export const PROGRESSREPORTPDF_GET = 'PROGRESSREPORTPDF_GET';